import React, { useContext } from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Checkbox,
} from '@mui/material';
import { CommonContext, GaintOFDOrdersContext } from '../../context';

const headCells = [
  { id: 'company_name', label: 'Merchant Name' },
  { id: 'orderName', label: 'Order Name' },
  { id: 'customer', label: 'Customer' },
  { id: 'tracking', label: 'Tracking Details' },
  { id: 'status', label: 'Status' },
  { id: 'merchant_warehouse.contact_person', label: 'Warehouse' },
  { id: 'payment', label: 'Payment Mode' },
  { id: 'orderDate', label: 'From' },
  { id: 'pod_file', label: 'To' },
];

export default function OrderTableHead({
  order,
  orderBy,
  onRequestSort,
  selected,
  onSelectAllClick,
  rowCount,
}) {
  const { user } = useContext(CommonContext);
  const { activeTab } = useContext(GaintOFDOrdersContext);

  let filteredHeadCells = user?.user_type === "Merchant" ? headCells.filter(headCell => headCell.id !== 'company_name') : headCells;

  if (activeTab === 21) {
    filteredHeadCells = filteredHeadCells.filter(headCell => headCell.id !== 'pod_file');
  } else if (activeTab === 2) {
    filteredHeadCells = filteredHeadCells.map(cell =>
      cell.id === 'orderName'
        ? { id: 'invoice_no', label: 'Invoice No' }
        : cell
    );
  }
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const numSelected = selected.length;

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            className="custom-checkbox"
          />
        </TableCell>
        {filteredHeadCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );

}